module.exports = __webpack_public_path__ + "static/img/globalIcon.a329a647.png";